import { useDelete } from '@refinedev/core';

export function useDeleteMeetingNote() {
  const { mutateAsync, error, isLoading, reset } = useDelete();

  const deleteMeetingNote = async (clientId: string, meetingNoteId: string) => {
    return mutateAsync({
      resource: `clients/${clientId}/meeting-notes`,
      id: meetingNoteId,
    });
  };

  return {
    deleteMeetingNote,
    error,
    isLoading,
    reset,
  };
}
